import { buildHead } from "@/lib/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/buyer/invoices")({
  head: () =>
    buildHead({
      title: "Invoices & Orders | LohaLink",
      description: "Your LohaLink invoices, GST documents and order history.",
      canonical: "/buyer/invoices",
      noindex: true,
    }),
  component: lazyRouteComponent(() => import("@/pages/Invoices")),
});
